import React, { useState, useCallback, useEffect } from 'react';
import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { user as userModel, rtc } from '@/models';
import { DEVICE_STATUS_REQUEST, DEVICE_TYPE } from '@/api';

export interface ShareScreenStateChangeResp {
  shareMemberUid: string;
  shareMemberDeviceId: string;
  state: number;
}

export default function useShareScreenStateChange() {
  const { rtc: RTCInstance, user } = useLocalStore(() => {
    return {
      rtc,
      user: userModel,
    };
  });
  const { formatMessage } = useIntl();

  const forceCloseVideo = async () => {
    try {
      await RTCInstance.closeCamera();
      await user?.updateDeviceStatus(
        String(RTCInstance.cid),
        DEVICE_TYPE.VIDEO,
        DEVICE_STATUS_REQUEST.CLOSE
      );
      message.info({
        content: formatMessage({ id: 'NOT_ALLOWED_TURNED_ON_DEVICE' }),
        noIcon: true,
      });
    } catch (e) {
      console.error(e);
    }
  };

  return forceCloseVideo;
}
